import { Padder, Spacer, Text } from '@oy/ui';
import { AccentIcon, AccentIconName } from '@oy/uiicon';
import classNames from 'classnames';
import React from 'react';
import styles from './Badge.module.css';

export enum BadgeStatus {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Default = 'default',
}

export type BadgeProps = {
  text: string;
  status?: BadgeStatus;
};

const Badge = ({ text, status = BadgeStatus.Default }: BadgeProps) => {
  const className = classNames(styles.container, styles[status]);
  let icon: AccentIconName;
  switch (status) {
    case BadgeStatus.Warning:
      icon = 'exclamation';
      break;
    case BadgeStatus.Error:
      icon = 'red-exclamation';
      break;
    default:
      icon = 'checkmark';
  }

  return (
    <Padder
      className={className}
      vertical={Padder.Size.XXXXS}
      horizontal={Padder.Size.S}
    >
      <div className={styles.content}>
        <Spacer right={Spacer.Size.XXS}>
          <AccentIcon name={icon} size="small" />
        </Spacer>
        <Text textStyle={Text.Style.BodyMdRegular}>{text}</Text>
      </div>
    </Padder>
  );
};

Badge.Status = BadgeStatus;

export default Badge;
